import { render, staticRenderFns } from "./Abnormalpackage.vue?vue&type=template&id=99a756e6&scoped=true&"
import script from "./Abnormalpackage.vue?vue&type=script&lang=js&"
export * from "./Abnormalpackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a756e6",
  null
  
)

export default component.exports